module.exports = __webpack_public_path__ + "img/3-low.0bd0b9ab.jpg";